export enum SIDE_BAR_HEADINGS {
  DEFAULT = "DEFAULT",
  SETTINGS = "SETTINGS",
}
